import { createContext, ReactNode, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Define the shape of the context
interface ProductIdContextType {
  product?: number;
  setProduct: (new_product: number) => void;
  accessToSalimax: boolean;
  accessToSalidomo: boolean;
  accessToSodiohome: boolean;
  accessToSodistore: boolean;
  accessToSodistoreGrid: boolean;
  accessToSodistorePro: boolean;
  setAccessToSalimax: (access: boolean) => void;
  setAccessToSalidomo: (access: boolean) => void;
  setAccessToSodiohome: (access: boolean) => void;
  setAccessToSodistore: (access: boolean) => void;
  setAccessToSodistoreGrid: (access: boolean) => void;
  setAccessToSodistorePro: (access: boolean) => void;
}

// Create the context.
export const ProductIdContext = createContext<ProductIdContextType | undefined>(
  undefined
);

// Create a UserContextProvider component
export const ProductIdContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const location = useLocation().pathname;
  const [accessToSalimax, setAccessToSalimax] = useState(() => {
    const storedValue = localStorage.getItem('accessToSalimax');
    return storedValue === 'true';
  });
  const [accessToSalidomo, setAccessToSalidomo] = useState(() => {
    const storedValue = localStorage.getItem('accessToSalidomo');
    return storedValue === 'true';
  });
  const [accessToSodiohome, setAccessToSodiohome] = useState(() => {
    const storedValue = localStorage.getItem('accessToSodiohome');
    return storedValue === 'true';
  });
  const [accessToSodistore, setAccessToSodistore] = useState(() => {
    const storedValue = localStorage.getItem('accessToSodistore');
    return storedValue === 'true';
  });
  const [accessToSodistoreGrid, setAccessToSodistoreGrid] = useState(() => {
    const storedValue = localStorage.getItem('accessToSodistoreGrid');
    return storedValue === 'true';
  });
  const [accessToSodistorePro, setAccessToSodistorePro] = useState(() => {
    const storedValue = localStorage.getItem('accessToSodistorePro');
    return storedValue === 'true';
  });
  // const [product, setProduct] = useState(location.includes('salidomo') ? 1 : 0);
  // const [product, setProduct] = useState<number>(
  //   productMapping[Object.keys(productMapping).find((key) => location.includes(key)) || ''] || -1
  // );
  const [product, setProduct] = useState<number>(() => {
    if (location.includes('salidomo')) {
      return 1;
    } else if (location.includes('sodistorepro')) {
      return 5;
    } else if (location.includes('sodiohome')) {
      return 2;
    } else if (location.includes('sodistoregrid')) {
      return 4;
    } else {
      return 0;
    }
  });

  const changeProductId = (new_product: number) => {
    // console.log('from provider' + new_product);
    setProduct(new_product);
  };

  const changeAccessSalimax = (access: boolean) => {
    setAccessToSalimax(access);
    localStorage.setItem('accessToSalimax', JSON.stringify(access));
  };

  const changeAccessSalidomo = (access: boolean) => {
    setAccessToSalidomo(access);
    localStorage.setItem('accessToSalidomo', JSON.stringify(access));
  };

  const changeAccessSodiohome = (access: boolean) => {
    setAccessToSodiohome(access);
    localStorage.setItem('accessToSodiohome', JSON.stringify(access));
  };
  const changeAccessSodistore = (access: boolean) => {
    setAccessToSodistore(access);
    localStorage.setItem('accessToSodistore', JSON.stringify(access));
  };
  const changeAccessSodistoreGrid = (access: boolean) => {
    setAccessToSodistoreGrid(access);
    localStorage.setItem('accessToSodistoreGrid', JSON.stringify(access));
  };
  const changeAccessSodistorePro = (access: boolean) => {
    setAccessToSodistorePro(access);
    localStorage.setItem('accessToSodistorePro', JSON.stringify(access));
  };

  return (
    <ProductIdContext.Provider
      value={{
        product,
        setProduct: changeProductId,
        accessToSalimax,
        accessToSalidomo,
        accessToSodiohome,
        accessToSodistore,
        accessToSodistoreGrid,
        accessToSodistorePro,
        setAccessToSalimax: changeAccessSalimax,
        setAccessToSalidomo: changeAccessSalidomo,
        setAccessToSodiohome: changeAccessSodiohome,
        setAccessToSodistore: changeAccessSodistore,
        setAccessToSodistoreGrid: changeAccessSodistoreGrid,
        setAccessToSodistorePro: changeAccessSodistorePro
      }}
    >
      {children}
    </ProductIdContext.Provider>
  );
};

export default ProductIdContextProvider;
